import { Popup, RadioGroup } from 'devextreme-react';
import React, { useEffect } from 'react';
import { getRoleName, GroupRoleType } from '../../Classes/UserGroups/GroupRole';
import { CompanyUser } from '../../Classes/UserGroups/CompanyUser';
import { useDispatch } from 'react-redux';
import { assignUserRole } from '../../Reducers/CompanyDataReducer';
import { Company } from '../../Classes/UserGroups/Company';
import useKeycloak from '../../Keycloak';

interface EditCompanyUserPopupProps {
    showPopup:boolean
    company:Company|undefined;
    companyUser:CompanyUser|undefined;
    onHiding:() => void;
}

type RoleTypeObject = { 
    type: GroupRoleType;
    text: string;
    description: string;
}

export function EditCompanyUserPopup(props:EditCompanyUserPopupProps) {

    const dispatch = useDispatch();
    const keycloak = useKeycloak();

    const roles : RoleTypeObject[] = [
        {
            type: GroupRoleType.Administrator,
            text: getRoleName(GroupRoleType.Administrator),
            description: 'Can do anything a maintainer can. Can also change the company name and delete the company.'
        },
        {
            type: GroupRoleType.Maintainer,
            text: getRoleName(GroupRoleType.Maintainer),
            description: 'Can do anything a member can, and can add or remove users from the company.'
        },
        {
            type: GroupRoleType.Member,
            text: getRoleName(GroupRoleType.Member),
            description: 'Can view who else is in the company.'
        }
    ];

    const [selectedRole, setSelectedRole] = React.useState<GroupRoleType|undefined>();

    useEffect(() => {
        setSelectedRole(roles.find(r => r.type === props.companyUser?.role)?.type);
    }, [props.companyUser?.role]);

    return (
        <Popup 
            title='Assign User Role'
            width='auto'
            height='auto'
            visible={props.showPopup}
            hideOnOutsideClick={true}
            onHiding={props.onHiding}>
                <div style={{padding: '0.5rem'}}>
                    <RadioGroup
                        dataSource={roles}
                        value={roles.find(r => r.type === selectedRole)}
                        onValueChange={(roleObject:RoleTypeObject) => {
                            let role = roleObject.type;
                            let token = keycloak.token;

                            dispatch(assignUserRole({
                                authToken: token, 
                                companyId: props.company?.id, 
                                userId: props.companyUser?.id, 
                                role: role}));

                            setSelectedRole(roleObject.type);
                        }}
                        itemRender={(roleObject:RoleTypeObject) => 
                        <div>
                            <h5 style={{margin: '0vh'}}>
                                {roleObject.text}
                            </h5>
                            <p style={{margin: '0.5vh'}}>
                                {roleObject.description}
                            </p>
                        </div>}/>
                </div>
        </Popup>
    );
}